import { action, makeAutoObservable, observable } from 'mobx';

export type Dimensions = {
  width: number,
  height: number
}

export type Offset = {
  top: number,
  left: number,
  bottom: number,
  right: number,
}

class ProfileStore {
  @observable dimensions?: Dimensions = undefined;

  @observable offset?: Offset = undefined;

  constructor() {
    makeAutoObservable(this);
  }

  @action setDimensions(dimensions: Dimensions): void {
    this.dimensions = dimensions;
  }

  @action setOffset(offset: Offset): void {
    this.offset = offset;
  }
}

export default new ProfileStore();
